const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const LoggedInUsers = ({ data }) => {
  return (
    <div>
      <p>
        {data.username} / {data.last_name} {data.first_name} - {data.belepve}
      </p>
    </div>
  );
};
